// App -> Find investors -> getUniqueInvestorTypes.js
import axios from 'axios';
import { API_URL } from '../../../config';

// Function to get unique investor types
const getUniqueInvestorTypes = async () => {
  try {
    // Send a request to the universal route to get only types
    const response = await axios.get(
      `${API_URL}/investors/filters?fields=type`,
      { withCredentials: true }
    );

    // Extract unique types from the response
    const { type } = response.data;

    return type?.values ?? []; // Return the types array
  } catch (error) {
    console.error('Error fetching unique investor types:', error);
    return []; // Return an empty array on error
  }
};

export default getUniqueInvestorTypes;
